import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../../axiosConfig';
import ChapaPaymentForm from '../Payment/ChapaPaymentForm';
import Notification from '../notification/Notification';
import { useNavigate, useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ViewTemplateOne from '../../view/ViewTemplateOne';
import ViewTemplateTwo from '../../view/ViewTemplateTwo';
import ViewTemplateThree from '../../view/ViewTemplateThree';
import ViewTemplateFour from '../../view/ViewTemplateFour';
import ViewTemplateFive from '../../view/ViewTemplateFive';
import ViewTemplateSix from '../../view/ViewTemplateSix';
import ViewTemplateSeven from '../../view/ViewTemplateSeven';
import ViewTemplateEight from '../../view/ViewTemplateEight';
import ViewTemplateNine from '../../view/ViewTemplateNine';
import ViewTemplateTen from '../../view/ViewTemplateTen';
import ViewTemplateEleven from '../../view/ViewTemplateEleven';
// import { Circles } from 'react-loader-spinner';

import '../../styles/UserTemplatePage.css';
import '../../styles/Notification.css';
import PaymentForm from '../Payment/PaypalPaymentForm';
import USDTWalletPayment from '../Payment/USDTWalletPayment';
import BinancePayPayment from '../Payment/BinancePayPayment';
import TelegramPayment from '../Payment/TelegramPayment';
import YenePayPaymentForm from '../Payment/YenePayPaymentForm';
import TeleBirrPaymentForm from '../Payment/TeleBirrPaymentForm';
import ResumeSkeleton from '../Loading/ResumeSkeleton';

const UserTemplatePage = ({ template, name }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const finalResumeRef = useRef(null);
    const paymentMethodsRef = useRef(null);
    const [hasPaid, setHasPaid] = useState(false);
    const [loading, setLoading] = useState(true);
    const [notification, setNotification] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const amount_paypal = '3';
    const amount_chapa = '96.62';
    const amount_binance = '1';

    useEffect(() => {
        const fetchPaymentStatus = async () => {
            try {
                const response = await axiosInstance.get('/api/paymentstatus/status');
                setHasPaid(response.data.hasPaid);
            } catch (error) {
                // console.error('Error fetching payment status:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentStatus();

        // Check for Chapa payment success
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('status') === 'success') {
            handlePaymentSuccess();
        }
    }, [location]);

    const handlePaymentSuccess = () => {
        setHasPaid(true);
        setNotification({ message: 'Payment successful!', isError: false });
    };

    const handleDownloadClick = () => {
        if (!hasPaid) {
            setNotification({ message: 'Please pay to download the resume.', isError: true });
            // Scroll to payment methods
            if (paymentMethodsRef.current) {
                paymentMethodsRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        }

        const input = finalResumeRef.current;
        if (!input) {
            return;
        }

        const promises = Array.from(input.getElementsByTagName('img')).map(img => {
            if (!img.complete) {
                return new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = reject;
                });
            }
            return Promise.resolve();
        });

        setIsDownloading(true);

        Promise.all(promises).then(() => {
            html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('p', 'mm', 'a4');
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgProps = pdf.getImageProperties(imgData);
                const imgWidth = pdfWidth;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

                let heightLeft = imgHeight;
                let position = 0;

                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;

                while (heightLeft > 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pdfHeight;
                }

                pdf.save('resume.pdf');
                setNotification({ message: 'Resume downloaded successfully!', isError: false });
            }).catch((error) => {
                //  console.error('Error generating PDF:', error);
                setNotification({ message: 'Failed to generate PDF. Please try again.', isError: true });
            }).finally(() => {
                setIsDownloading(false); // Reset download state after finishing
            });
        }).catch((error) => {
            // console.error('Error loading images:', error);
            setNotification({ message: 'Failed to load images. Please try again.', isError: true });
            setIsDownloading(false);
        });
    };

    const renderTemplate = () => {
        switch (name) {
            case 'Professional':
                return <ViewTemplateOne key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Modern':
                return <ViewTemplateTwo key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Creative':
                return <ViewTemplateThree key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Simple':
                return <ViewTemplateFour key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Elegant':
                return <ViewTemplateFive key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Classic':
                return <ViewTemplateSix key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Tech-Savvy':
                return <ViewTemplateSeven key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Entrepreneur':
                return <ViewTemplateEight key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Analytical':
                return <ViewTemplateNine key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Consultant':
                return <ViewTemplateTen key={template?.id} template={template} isDownloading={isDownloading} />;
            case 'Academic':
                return <ViewTemplateEleven key={template?.id} template={template} isDownloading={isDownloading} />;
            default:
                return (
                    <div className="template-content" id="template-content">
                        <p>You have no resume</p>
                    </div>
                );
        }
    };

    if (loading) {
        return (
            <div className="loader-container">
                <ResumeSkeleton />
            </div>
        )
    }

    return (
        <div className='final'>

            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}

            <div className='buttons'>
                <button onClick={() => navigate(`/edit-template`)} className="button">Edit Resume</button>
                <button onClick={() => navigate(`/`)} className="button">Select Another Template</button>
                <button onClick={handleDownloadClick} className="button">Download Resume</button>
            </div>

            <div className='final-container'>
                <div ref={finalResumeRef} className='final-resume'>
                    {renderTemplate()}
                </div>
            </div>

            {!hasPaid && (
                <div ref={paymentMethodsRef} className='payment_methods_container'>
                    <h2>Make Payment to Download Your Resume</h2>
                    <h3>You can select your preferred payment method.</h3>

                    <div className='payment_methods'>
                        <div className='pay'>
                            <p> PayPal, Debit and Credit Card Payment Methods </p>
                            <PaymentForm amount={amount_paypal} onPaymentSuccess={handlePaymentSuccess} />
                        </div>

                        <div className='pay'>
                            <p>Ethiopian(Chapa) Payment Method</p>
                            <ChapaPaymentForm amount={amount_chapa} onPaymentSuccess={handlePaymentSuccess} />
                        </div>

                        <div className='pay'>
                            <p>Binance Payment Method</p>
                            <BinancePayPayment onPaymentSuccess={handlePaymentSuccess} amount={amount_binance} />
                        </div>

                        {/* <div className='pay'>
                            <p>Ethiopian(YenePay) Payment Method</p>
                            <YenePayPaymentForm amount={amount_chapa} onPaymentSuccess={handlePaymentSuccess} />
                        </div>

                        <div className='pay'>
                            <p>Blockchain USDT Payment Method</p>
                            <USDTWalletPayment onPaymentSuccess={handlePaymentSuccess} amount={amount_block_chain} />
                        </div>

                        <div className='pay'>
                            <p>Blockchain USDT Payment Method</p>
                            <TelegramPayment onPaymentSuccess={handlePaymentSuccess} amount={amount_block_chain} />
                        </div>

                        <div className='pay'>
                            <p>Ethiopian(TeleBirr) Payment Method</p>
                            <TeleBirrPaymentForm amount={amount_chapa} onPaymentSuccess={handlePaymentSuccess} />
                        </div> */}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserTemplatePage;
